module.exports = __webpack_public_path__ + "static/media/PDRegisterImage.c8f169da.png";